import React from 'react';
import './Help.css';
import './shared.css';

function Help({ onBack }) {
  return (
    <div className="help-page">
      <div className="menu-bar">
        <button className="menu-button" onClick={onBack}>Back to Home</button>
      </div>
      
      <h2>Help</h2>
      
      <div className="help-section">
        <h3>Hello!</h3>
        <p>
            I made this app for us to chose our death lists for the year.<br/>
            This is a work in progress - not tested, and probably has bugs.<br/>
            Please let me know if you find any issues or need help.<br/>
            <br/>
            Ben
        </p>
      </div>

      <div className="help-section">
        <h3>Creating Your List</h3>
        <ul>
          <li>Each person can select up to 10 celebrities</li>
          <li>Click "Start Your List Here" to get started</li>
          <li>Use the search bar to find celebrities</li>
          <li>In the search results, click "Add to List" to add someone to your list</li>
          <li>In the search results, click "Show Details" to see more information about the celebrity - use this to check you've found the right person</li>
          <li>The app won't have details for everyone it finds, it depends on the data I get back, sorry about that</li>
          <li>You can't pick a celebrity that someone else has already chosen</li>
          <li>Only living celebrities can be selected - the app doesn't always get it right, and may list dead celebrities by mistake. Use the "Show Details" button to check </li>
          <li>Once your list is complete, you can only make changes by removing and replacing celebrities</li>
          <li>You can make changes to your list upto the 1st January 2025</li>
        </ul>
      </div>


      <div className="help-section">
        <h3>Viewing Lists</h3>
        <p>
          You can view everyone else's lists at any time, provided they've made a start.
          Each list shows how many celebrities have been selected out of the maximum 10.
        </p>
      </div>
    </div>
  );
}

export default Help; 